import axios from 'axios';

const API_BASE = '/api/employees';

export const employeeService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  },

  addPayHistory: async (id, data) => {
    const response = await axios.post(`${API_BASE}/${id}/pay-history`, data);
    return response.data;
  },

  deletePayHistory: async (id, entryId) => {
    const response = await axios.delete(`${API_BASE}/${id}/pay-history/${entryId}`);
    return response.data;
  },

  addWorkHistory: async (id, data) => {
    const response = await axios.post(`${API_BASE}/${id}/work-history`, data);
    return response.data;
  },

  deleteWorkHistory: async (id, entryId) => {
    const response = await axios.delete(`${API_BASE}/${id}/work-history/${entryId}`);
    return response.data;
  },

  addNote: async (id, data) => {
    const response = await axios.post(`${API_BASE}/${id}/notes`, data);
    return response.data;
  },

  deleteNote: async (id, noteId) => {
    const response = await axios.delete(`${API_BASE}/${id}/notes/${noteId}`);
    return response.data;
  }
};
